import React from 'react';
import Image from 'next/image';
import { Tooltip } from '@nextui-org/react';
import { promptStyles } from '../generate-sub/prompt-styles';
import { LoraModel } from '@/types/lora';
import { logoPlaceholder } from '@/utils/placeholders';

interface PromptStartersDesktopProps {
  setPrompt: (prompt: string) => void;
  setSelectedLoraModel: (model: LoraModel | null) => void;
  productPromptExamples?: any[];
  subject?: string;
  triggerWord?: string;
}

export const PromptStartersDesktop: React.FC<PromptStartersDesktopProps> = ({
  setPrompt,
  setSelectedLoraModel,
  productPromptExamples = [],
  subject,
  triggerWord
}) => {
  const allPrompts = [
      ...productPromptExamples.map(example => ({
          name: example.text.slice(0, 20) + '...',
          prompt: example.text,
          image: example.original,
          loraModel: example.additional_lora_product_id,
      })),
      ...promptStyles(subject, triggerWord),
  ];

  return (
    <div className="hidden md:block">
      <h2 className="mb-4 text-xl font-semibold sticky top-0 bg-white dark:bg-black z-10">
        Prompt Starters
      </h2>
      <div className="grid grid-cols-2 gap-4 max-h-[350px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-700 scrollbar-track-gray-100 dark:scrollbar-track-gray-900 pr-2 sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-3">
        {allPrompts.map((style, index) => (
          <div
            key={index}
            className="flex cursor-pointer flex-col items-center relative group"
            onClick={() => {
              setPrompt(style.prompt || '');
              setSelectedLoraModel(style.loraModel || null);
            }}
          >
            <Image
              src={style.image}
              alt={style.name}
              className="mb-2 h-24 w-24 rounded-md object-cover"
              width={100}
              height={100}
            />
            <p className="text-center text-sm">{style.name}</p>
            {style.loraModel && (
              <Tooltip 
                content={`Uses ${style.loraModel.name} LoRA model`}
                placement="top"
              >
                <div className="absolute top-2 right-2 bg-black/60 rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <Image
                    src={style.loraModel?.image ?? logoPlaceholder}
                    alt={style.loraModel.name}
                    width={20}
                    height={20}
                    className="rounded-full"
                  />
                </div>
              </Tooltip>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}; 